import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "el-dropdown-link cursor-pt",
  style: {"color":"#0586FE","margin-left":"10px","font-size":"14px"}
}
const _hoisted_2 = { class: "dropdown-content" }
const _hoisted_3 = { class: "checked" }
const _hoisted_4 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/checked_icon.png",
  alt: ""
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/ship_icon.png",
  alt: "",
  class: "icon"
}, null, -1)
const _hoisted_6 = { class: "checked" }
const _hoisted_7 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/checked_icon.png",
  alt: ""
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/air_icon.png",
  alt: "",
  class: "icon"
}, null, -1)

import { t } from '@/plugins/i18n'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['transportType'],
  emits: ['change'],
  setup(__props, { emit: emits }) {

const props = __props


const selectTransportRef = ref()
const changeTransportType = (type:number) => {
  if (props.transportType === type) return
  selectTransportRef.value.handleClose()
  emits('change', type)
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    trigger: "click",
    "popper-class": "choice-shop-pop",
    ref: (_value, _refs) => {
      _refs['selectTransportRef'] = _value
      selectTransportRef.value = _value
    }
  }, {
    dropdown: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["dropdown-item flex-ter", { active: __props.transportType === 1 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTransportType(1)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            (__props.transportType === 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('海运')), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["dropdown-item flex-ter", { active: __props.transportType === 2 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTransportType(2)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            (__props.transportType === 2)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('空运')), 1)
        ], 2)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('请选择')) + "> ", 1)
    ]),
    _: 1
  }, 512))
}
}

})